export function setStateProducts(state, products) {
    if (state.params.branchoffice_warehouse_id) {
        products.map(p => {
            if (p.inventory.length) {
                if (+p.inventory[0].branchoffice_warehouse_id !== +state.params.branchoffice_warehouse_id) {
                    let inventory_0 = JSON.parse(JSON.stringify(p.inventory[0]));

                    let index = p.inventory.findIndex(i => +i.branchoffice_warehouse_id === +state.params.branchoffice_warehouse_id);

                    if (index >= 0) {
                        p.inventory[0] = p.inventory[index];
                        p.inventory[index] = inventory_0;
                    }
                }
            }
        });
    }

    state.products = products;
}

export function setbranchoffice_warehouse(state, data) {
  state.params.branchoffice_warehouse_id = data.branchoffice_warehouse;
  state.params.branchoffice_id = data.branchoffice;
}

export function setDestinationBranchOfficeWarehouse(state, data) {
    state.params.destination_branchoffice_warehouse_id = data.destination_branchoffice_warehouse_id;
    state.params.destination_branchoffice_id = data.destination_branchoffice_id;
}


export function setAvailability(state, availability) {
  state.availability = availability;
}
export function setavAilability_totals(state, availability_totals) {
  state.availability_totals = availability_totals;
}
export function setStateProductspagination(state, productspagination) {
  state.productspagination = productspagination;
}
export function setJustify_availability(state, justify_availability) {
  state.justify_availability = justify_availability;
}
export function setbranchoffice_warehouse_id(state, warehouse_id) {
  state.params.branchoffice_warehouse_id = warehouse_id;
}

export function setWarehouseId(state, warehouse_id) {
  state.params.warehouse_id = warehouse_id;
}
export function setTitleBranchoffice(state, data) {
  state.titleBranchoffice = data[0].branchoffice;
}

export function setContacts(state, contacts) {
  state.contacts = contacts;
}
export function setContactDefault(state, contact) {
   if (contact){
       let default_contact = {
           "id": contact.id,
           "identification": contact.identification,
           "name": contact.name,
           "surname": contact.surname,
           "full_name_with_identification": contact.full_name_with_identification,
           "full_name": contact.full_name
       }
       state.contacts.push(default_contact);
       state.params_history_products.contact_id = contact.id;
       state.params.contact_id = contact.id;
   }

}
export function setHistoryReportProductsContact(state, data){
    console.log(data)
    state.history_products = data ?data.data: [];
}
export function setHistoryReportProductsParams(state, data){
    state.params_history_products.contact_id = data.contact_id;
    state.params_history_products.product_id = data.product_id;
}

export function setBranchofficeWarehouse(state, data) {
    state.branchoffice_warehouse = data
}

/**
 * Establecer un valor para la variable branch_offices_warehouses.
 */
export function setBranchOfficesWarehouses(state, branch_offices_warehouses) {
    state.branch_offices_warehouses = branch_offices_warehouses;
}



// WEBPACK FOOTER //
// ./src/modules/availability-inquiry/mutations.js